import { LoadingOutlined } from "@ant-design/icons";
import { Collapse, Select, Spin, theme } from "antd";
import React, { useEffect, useState } from "react";
import { useMainContext } from "../../Context";
import { API_SERVER } from "../../Server";
import { ToDateJalali, renderPrice } from "../../Utils/functions";
import { ArrowSquare, Download } from "../../Utils/icons";
import AkoModal from "../Modal";
import Paginate from "../Paginate";
import "./style.scss";
import TextArea from "../Form/Textarea";
import Input from "../Form/Input";

const { Panel } = Collapse;

const AkoTable = ({ paginate = false, subtitle = false, data = [] }) => {
  const { token } = theme.useToken();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({});
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({});

  const {
    state: { user },
    post,
    get,
  } = useMainContext();
  const download = async (id, hash) => {
    window.open(`${API_SERVER}/user/invoices/${id}?t=${hash}`);
  };
  const getData = async () => {
    const { data } = await get("/user/user");
    setForm({ ...form, address: data.address });
  };
  useEffect(() => {
    getData();
  }, []);

  const getProvince = async () => {
    const { data } = await get("/user/tapin/state-tree");
    setItems(data.entries);
  };
  useEffect(() => {
    getProvince();
  }, []);

  const orderFactor = async () => {
    setLoading(true);
    await post(`/user/order-factors`, {
      order_id: modal.show.id,
      ...form,
      province: form.id,
    });
    setLoading(false);
    setModal({});
  };
  return (
    <>
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              <th scope="col fw-600 fs-11 lh-19 ">#</th>
              <th scope="col fw-600 fs-11 lh-19 ">شماره فاکتور</th>
              <th scope="col fw-600 fs-11 lh-19 ">عنوان فاکتور</th>
              <th scope="col fw-600 fs-11 lh-19 ">مبلغ فاکتور</th>
              <th scope="col fw-600 fs-11 lh-19 ">تاریخ فاکتور</th>
              <th scope="col fw-600 fs-11 lh-19 ">دریافت فاکتور</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, key) => {
              return (
                <>
                  <tr>
                    <th
                      scope="row text-right fw-400 num"
                      style={{
                        fontWeight: "400",
                        textAlign: "right",
                      }}
                    >
                      {key + 1}
                    </th>
                    <th
                      scope="row text-right fw-400 num"
                      style={{
                        fontWeight: "400",
                        textAlign: "right",
                      }}
                    >
                      {item?.sepidar_invoice_number}
                    </th>
                    <td>{item?.plan?.title}</td>
                    <td className="num" style={{ fontWeight: "400" }}>
                      {renderPrice(
                        `${
                          +item.price +
                          +item.feature +
                          +item.tax -
                          +item.discount
                        }`
                      )}
                    </td>
                    <td className="num" style={{ fontWeight: "400" }}>
                      {ToDateJalali(item.order_date)}
                    </td>
                    <td
                      className="pointer"
                      // style={{ display: "flex", gap: "10px" }}
                    >
                      <div style={{ display: "flex", gap: "10px" }}>
                        <div
                          style={{
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",

                            justifyContent: "center",
                          }}
                          className="hover-able"
                        >
                          <Download
                            onClick={() => {
                              download(item.sepidar_invoice_number, item.hash);
                            }}
                          />
                        </div>
                        <div
                          style={{
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",

                            justifyContent: "center",
                          }}
                          className="hover-able"
                        >
                          <img
                            onClick={() => {
                              if (item.order_factor) {
                                setModal({
                                  show: item,
                                  address: item?.user?.address,
                                });
                              }
                            }}
                            className="factor-btn"
                            data-active={
                              item?.order_factor?.length ? true : false
                            }
                            src={require("../../Assets/icons/routing.png")}
                            alt=""
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="mobile-table">
        <Collapse
          defaultActiveKey={1}
          expandIcon={({ isActive }) => (
            <ArrowSquare
              style={{ transform: isActive ? "rotateZ(180deg)" : "" }}
            />
          )}
          expandIconPosition="right"
          style={{ background: token.colorBgContainer }}
        >
          <div className="title-mobile-table">
            <div className="mobile-table-row">
              <p className="row-id fs-12 fw-400 lh-20">#</p>
              <p className="fw-400 fs-12 lh-20">عنوان فاکتور</p>
            </div>
          </div>
          {data.map((item, key) => (
            <Panel
              header={
                <div className="mobile-table-row">
                  <p className="row-id fs-12 fw-400 lh-20 num">{key + 1}</p>
                  <p className="fw-400 fs-12 lh-20">{item?.plan?.title}</p>
                </div>
              }
              key={key + 1}
            >
              <div className="mobile-table-content">
                <div className="key-value" style={{ marginBottom: "8px" }}>
                  <p className="key fs-11 lh-19 fw-600">شماره فاکتور</p>
                  <p className="value fs-12 lh-20 fw-400">
                    {item.sepidar_invoice_number}
                  </p>
                </div>
                <div className="key-value" style={{ marginBottom: "8px" }}>
                  <p className="key fs-11 lh-19 fw-600">مبلغ فاکتور</p>
                  <p className="value fs-12 lh-20 fw-400">
                    {renderPrice(item.price)}
                  </p>
                </div>
                <div className="key-value" style={{ marginBottom: "8px" }}>
                  <p className="key fs-11 lh-19 fw-600">تاریخ فاکتور</p>
                  <p className="value fs-12 lh-20 fw-400">
                    {ToDateJalali(item.order_date)}
                  </p>
                </div>
                <div className="key-value">
                  <p className="key fs-11 lh-19 fw-600">دریافت فاکتور</p>
                  <p
                    onClick={() => {
                      download(item.sepidar_invoice_number, item.hash);
                    }}
                    className="value fs-12 lh-20 fw-400 pointer"
                  >
                    {" "}
                    <Download />
                  </p>
                  <p>
                    <img
                      onClick={() => {
                        if (item.order_factor) {
                          setModal({
                            show: item,
                            address: item?.user?.address,
                          });
                        }
                      }}
                      className="factor-btn"
                      data-active={item?.order_factor?.length ? true : false}
                      src={require("../../Assets/icons/routing.png")}
                      alt=""
                    />
                  </p>
                </div>
              </div>
            </Panel>
          ))}
        </Collapse>
      </div>
      {paginate && <Paginate data={paginate} />}
      {subtitle && (
        <div className="subtitle-table">
          <p className="fs-11 fw-600 lh-19 text-center">
            فاکتور‌های قبل از سال ۱۴۰۲ از طریق این سامانه قابل دریافت نمی‌باشند،
            برای دریافت با پشتیبانی در تماس باشید.
          </p>
        </div>
      )}
      <AkoModal
        open={modal.show}
        onClose={() => {
          setModal({});
        }}
      >
        <p className="text-main fs-16 fw-500 num">
          فاکتور در خواستی به شماره {modal?.show?.sepidar_invoice_number} به
          آدرس ثبت شده در پنل ارسال خواهد شد.
        </p>
        <p className="text-main fs-14 fw-400">
          توجه داشته باشید هزینه ارسال به عهده خودتان می باشد
        </p>
        <div className="select-province">
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Select
              // style={{ width: 120 }}
              // onChange={handleChange}
              placeholder="استان"
              options={items.map(item => {
                return { value: item.code, label: item.title };
              })}
              onChange={id => {
                setForm({ ...form, id });
              }}
            />
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <Select
              // style={{ width: 120 }}
              // onChange={handleChange}
              placeholder="شهر"
              options={items
                ?.filter(ele => ele.code === form.id)[0]
                ?.cities?.map(item => {
                  return { value: item.code, label: item.title };
                })}
              disabled={!form.id}
              onChange={city => {
                setForm({ ...form, city });
              }}
            />
          </div>
        </div>
        <Input
          props={{
            placeholder: "",
            onChange: ({ target: { value } }) => {
              setForm({ ...form, address: value });
            },
            defaultValue: form.address,
          }}
          label="آدرس :"
        />
        <Input
          props={{
            placeholder: "",
            onChange: ({ target: { value } }) => {
              setForm({ ...form, postal_code: value });
            },
            defaultValue: form.postal_code,
          }}
          label="کد پستی :"
        />
        <div
          className="d-flex jcb "
          style={{
            marginTop: "30px",
            display: "flex",
            gap: "5px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={() => {
              orderFactor();
            }}
            disabled={loading}
            style={{
              background: "#00AF85",
              boxShadow: "0px 0px 10px 5px rgba(25, 38, 60, 0.05)",
              borderRadius: "10px",
              border: "none",
              color: "#F5F7F9",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "22px",
              padding: "7px 18px",
            }}
          >
            {loading ? (
              <>
                <Spin
                  indicator={
                    <LoadingOutlined
                      color="#fff"
                      style={{ color: "#fff" }}
                      spin
                    />
                  }
                />
              </>
            ) : (
              <>تایید</>
            )}
          </button>
          <button
            style={{
              background: "#D82148",
              boxShadow: "0px 0px 10px 5px rgba(25, 38, 60, 0.05)",
              borderRadius: "10px",
              border: "none",
              color: "#F5F7F9",
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "22px",
              padding: "7px 18px",
            }}
            onClick={() => {
              setModal({});
            }}
          >
            انصراف
          </button>
        </div>
      </AkoModal>
    </>
  );
};

export default AkoTable;
